﻿//   function SmoothlyMenu() {
//     if (!jQuery('body').hasClass('mini-navbar') || jQuery('body').hasClass('body-small')) {
//       // Hide menu in order to smoothly turn on when maximize menu
//       jQuery('#side-menu').hide();
//       // For smoothly turn on menu
//       setTimeout(
//         function () {
//           jQuery('#side-menu').fadeIn(400);
//         }, 200);
//     } else if (jQuery('body').hasClass('fixed-sidebar')) {
//       jQuery('#side-menu').hide();
//       setTimeout(
//         function () {
//           jQuery('#side-menu').fadeIn(400);
//         }, 100);
//     } else {
//       // Remove all inline style from jquery fadeIn function to reset menu state
//       jQuery('#side-menu').removeAttr('style');
//     }
//   }
// // Config box
// function localStorageSupport(){
// 	return ('localStorage' in window);
// }
// // Enable/disable fixed top navbar
// $('#fixednavbar1').click(function () {
//     if ($('#fixednavbar1').is(':checked')) {
//         $(".navbar-static-top").removeClass('navbar-static-top').addClass('navbar-fixed-top');
//         $("body").removeClass('boxed-layout');
//         $("body").addClass('fixed-nav');
//         $('#boxedlayout').prop('checked', false);

//         if (localStorageSupport) {
//             localStorage.setItem("boxedlayout", 'off');
//         }

//         if (localStorageSupport) {
//             localStorage.setItem("fixednavbar1", 'on');
//         }
//     } else {
//         $(".navbar-fixed-top").removeClass('navbar-fixed-top').addClass('navbar-static-top');
//         $("body").removeClass('fixed-nav');
//         $("body").removeClass('fixed-nav-basic');
//         $('#fixednavbar2').prop('checked', false);

//         if (localStorageSupport) {
//             localStorage.setItem("fixednavbar1", 'off');
//         }

//         if (localStorageSupport) {
//             localStorage.setItem("fixednavbar2", 'off');
//         }
//     }
// });

// // Enable/disable fixed top navbar
// $('#fixednavbar2').click(function () {
//     if ($('#fixednavbar2').is(':checked')) {
//         $(".navbar-static-top").removeClass('navbar-static-top').addClass('navbar-fixed-top');
//         $("body").removeClass('boxed-layout');
//         $("body").addClass('fixed-nav').addClass('fixed-nav-basic');
//         $('#boxedlayout').prop('checked', false);

//         if (localStorageSupport) {
//             localStorage.setItem("boxedlayout", 'off');
//         }

//         if (localStorageSupport) {
//             localStorage.setItem("fixednavbar2", 'on');
//         }
//     } else {
//         $(".navbar-fixed-top").removeClass('navbar-fixed-top').addClass('navbar-static-top');
//         $("body").removeClass('fixed-nav').removeClass('fixed-nav-basic');
//         $('#fixednavbar1').prop('checked', false);

//         if (localStorageSupport) {
//             localStorage.setItem("fixednavbar2", 'off');
//         }
//         if (localStorageSupport) {
//             localStorage.setItem("fixednavbar1", 'off');
//         }
//     }
// });

// // Enable/disable fixed sidebar
// $('#fixedsidebar').click(function () {
//     if ($('#fixedsidebar').is(':checked')) {
//         $("body").addClass('fixed-sidebar');
//         $('.sidebar-collapse').slimScroll({
//             height: '100%',
//             railOpacity: 0.9
//         });

//         if (localStorageSupport) {
//             localStorage.setItem("fixedsidebar", 'on');
//         }
//     } else {
//         $('.sidebar-collapse').slimscroll({ destroy: true });
//         $('.sidebar-collapse').attr('style', '');
//         $("body").removeClass('fixed-sidebar');

//         if (localStorageSupport) {
//             localStorage.setItem("fixedsidebar", 'off');
//         }
//     }
// });

// // Enable/disable collapse menu
// $('#collapsemenu').click(function () {
//     if ($('#collapsemenu').is(':checked')) {
//         $("body").addClass('mini-navbar');
      
//         SmoothlyMenu();

//         if (localStorageSupport) {
//             localStorage.setItem("collapse_menu", 'on');
//         }

//     } else {
//         $("body").removeClass('mini-navbar');
        
//         SmoothlyMenu();

//         if (localStorageSupport) {
//             localStorage.setItem("collapse_menu", 'off');
//         }
//     }
// });

// $('#flatdesign').click(function () {
   
//     if ($('#flatdesign').is(':checked')) {
        
//         $("body").removeClass('md-skin');
       

//     } else {
//         $("body").addClass('md-skin');
      
//     }
// });


// // Enable/disable boxed layout
// $('#boxedlayout').click(function () {
//     if ($('#boxedlayout').is(':checked')) {
//         $("body").addClass('boxed-layout');
//         $('#fixednavbar1').prop('checked', false);
//         $('#fixednavbar2').prop('checked', false);
//         $(".navbar-fixed-top").removeClass('navbar-fixed-top').addClass('navbar-static-top');
//         $("body").removeClass('fixed-nav');
//         $("body").removeClass('fixed-nav-basic');
//         $(".footer").removeClass('fixed');
//         $('#fixedfooter').prop('checked', false);

//         if (localStorageSupport) {
//             localStorage.setItem("fixednavbar1", 'off');
//         }

//         if (localStorageSupport) {
//             localStorage.setItem("fixednavbar2", 'off');
//         }

//         if (localStorageSupport) {
//             localStorage.setItem("fixedfooter", 'off');
//         }


//         if (localStorageSupport) {
//             localStorage.setItem("boxedlayout", 'on');
//         }
//     } else {
//         $("body").removeClass('boxed-layout');

//         if (localStorageSupport) {
//             localStorage.setItem("boxedlayout", 'off');
//         }
//     }
// });

// // Enable/disable fixed footer
// $('#fixedfooter').click(function () {
//     if ($('#fixedfooter').is(':checked')) {
//         $('#boxedlayout').prop('checked', false);
//         $("body").removeClass('boxed-layout');
//         $(".footer").addClass('fixed');

//         if (localStorageSupport) {
//             localStorage.setItem("boxedlayout", 'off');
//         }

//         if (localStorageSupport) {
//             localStorage.setItem("fixedfooter", 'on');
//         }
//     } else {
//         $(".footer").removeClass('fixed');

//         if (localStorageSupport) {
//             localStorage.setItem("fixedfooter", 'off');
//         }
//     }
// });

// // SKIN Select
// $(document).on('click', '.spin-icon',function () {
//     $(".theme-config-box").toggleClass("show");
// });

// // Default skin
// $('.s-skin-4').click(function () {
//     $("#avgTimings").removeClass("skin-1timing");
//     $("#avgTimings").removeClass("skin-3timing");
//     $("#avgTimings").addClass("skin-0avgTimings");
//     $("body").removeClass("skin-0");
//     $("body").removeClass("skin-1");
//     $("body").removeClass("skin-2");
//     $("body").removeClass("skin-3");
//     localStorage.setItem('skin_type','s-skin-4');
//     //saveUserPreferences();
    
// });

// // Green skin
// $('.s-skin-0').click(function () {
//     $("#avgTimings").removeClass("skin-1timing");
//     $("#avgTimings").removeClass("skin-3timing");
//     $("#avgTimings").removeClass("skin-4timing");
//     $("#avgTimings").addClass("skin-0avgTimings");
//     $("body").removeClass("skin-4");
//     $("body").removeClass("skin-1");
//     $("body").removeClass("skin-2");
//     $("body").removeClass("skin-3");
//     $("body").addClass("skin-0");
//     localStorage.setItem('skin_type','s-skin-0');
//     //saveUserPreferences();
   
   
// });

// // Blue skin
// $('.s-skin-1').click(function () {
//     $("body").removeClass("skin-2");
//     $("body").removeClass("skin-3");
//     $("body").removeClass("skin-0");
//     $("body").removeClass("skin-4");
//     $("body").addClass("skin-1");
//     $("#avgTimings").removeClass("skin-0avgTimings");
//     $("#avgTimings").removeClass("skin-3timing");
//     $("#avgTimings").removeClass("skin-4timing");
//     $("#avgTimings").addClass("skin-1timing");
//     localStorage.setItem('skin_type','s-skin-1');
//     //saveUserPreferences();
  
  
// });

// // Inspinia ultra skin
// $('.s-skin-2').click(function () {
//     $("body").removeClass("skin-1");
//     $("body").removeClass("skin-3");
//     $("body").addClass("skin-2");
//     $("#avgTimings").addClass("skin-3timing");
//     localStorage.setItem('skin_type','s-skin-2');
//     //saveUserPreferences();

// });

// // Yellow skin
// $('.s-skin-3').click(function () {
//     $("body").removeClass("skin-0");
//     $("body").removeClass("skin-1");
//     $("body").removeClass("skin-2");
//     $("body").removeClass("skin-4");
//     $("body").addClass("skin-3");
//     $("#avgTimings").removeClass("skin-1timing");
//     $("#avgTimings").removeClass("skin-4timing");
//     $("#avgTimings").addClass("skin-3timing");
//     localStorage.setItem('skin_type','s-skin-3');
//     //saveUserPreferences();
    
// });

// // Black skin
// $('.s-skin-4').click(function () {
//     $("body").removeClass("skin-0");
//     $("body").removeClass("skin-1");
//     $("body").removeClass("skin-2");
//     $("body").removeClass("skin-3");
//     $("body").addClass("skin-4");
//     $("#avgTimings").removeClass("skin-3timing");
//     $("#avgTimings").removeClass("skin-1timing");
//     $("#avgTimings").addClass("skin-4timing");
//     localStorage.setItem('skin_type','s-skin-4');
//     //saveUserPreferences();
  
// });

// if (localStorageSupport) {
//     var collapse = localStorage.getItem("collapse_menu");
//     var fixedsidebar = localStorage.getItem("fixedsidebar");
//     var fixednavbar = localStorage.getItem("fixednavbar1");
//     var fixednavbar2 = localStorage.getItem("fixednavbar2");
//     var boxedlayout = localStorage.getItem("boxedlayout");
//     var fixedfooter = localStorage.getItem("fixedfooter");
//     var flatdesign = localStorage.getItem("flatdesign_menu");

//     if (collapse === 'on') {
//         $('#collapsemenu').prop('checked', 'checked');
//     }
//     if (fixedsidebar === 'on') {
//         $('#fixedsidebar').prop('checked', 'checked');
//     }
//     if (fixednavbar === 'on') {
//         $('#fixednavbar1').prop('checked', 'checked');
//     }
//     if (fixednavbar2 === 'on') {
//         $('#fixednavbar2').prop('checked', 'checked');
//     }
//     if (boxedlayout === 'on') {
//         $('#boxedlayout').prop('checked', 'checked');
//     }
//     if (fixedfooter === 'on') {
//         $('#fixedfooter').prop('checked', 'checked');
//     }
//     if (fixedfooter === 'on') {
//         $('#flatdesign').prop('checked', 'checked');
//     }
// }
// function saveUserPreferences(){
//     let preference={
//         boxedlayout:localStorage.boxedlayout,
//         collapse_menu: localStorage.collapse_menu,
//         fixedfooter: localStorage.fixedfooter,
//         fixednavbar1: localStorage.fixednavbar1,
//         fixednavbar2: localStorage.fixednavbar2,
//         fixedsidebar: localStorage.fixedsidebar,
//         skin_type:localStorage.skin_type
//       }
//     $.ajax({
//         url:'/access-control/user-preferences',
//         type:'POST',
//         contentType:'application/json',
//         data:{user_prefernces:preference,userId:localStorage.currentuser_loginId},
//         success:function(response){
//             if(response.status) 
//             alert('Success');  
//         },
//         error:function(error){
//             alert('Error'); 
//         }
//     });
// }